module.exports = __webpack_public_path__ + "img/bus-outlined-grey.8ede748e.svg";